import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'antd';
import { ReactComponent as CloseIcon } from './img/icon-X.svg';
import { getURLForNavKey } from './lib/data';
import { BrowserView, TabletView, isBrowser, isTablet } from 'react-device-detect';
import InstagramLinkIcon from './InstagramLinkIcon';
import LinkedInLinkIcon from './LinkedInLinkIcon';
import './Navigation.css';

const { SubMenu } = Menu;

export default class Navigation extends Component {
  static propTypes = {
    visible: PropTypes.bool,
    onToggleNavigation: PropTypes.func,
  }

  handleClose = () => {
    this.props.onToggleNavigation();
  }

  handleClick = (item) => {
    const url = getURLForNavKey(item.key);
    if (url.search('http') === -1) {
      this.props.onToggleNavigation();
    }
    window.location.href = url;
  }

  render() {
    if (!this.props.visible) {
      return null;
    }

    return (
      <nav className={(isBrowser || isTablet) ? 'Browser' : 'Mobile'}>
        <a className="close-nav" onClick={this.handleClose}>
          <CloseIcon />
        </a>
        <Menu theme="dark" mode="inline" onClick={this.handleClick}>
          <Menu.Item key="what-is-culture">What Is Culture?</Menu.Item>
          <SubMenu key="purpose" title="Purpose" className="purpose-submenu">
            <Menu.Item key="why-our-company-exists">Intro: Why Our Company Exists</Menu.Item>
            <Menu.Item key="the-why">The Why, How, and What</Menu.Item>
            <Menu.Item key="own-the-moment">Own the Moment</Menu.Item>
            <Menu.Item key="figure-out-what-you-want">Figure out What You Want...</Menu.Item>
          </SubMenu>
          <SubMenu key="actions" title="Actions" className="actions-submenu">
            <Menu.Item key="how-teams-put-values-to-work">Intro: How Teams Put Values to Work</Menu.Item>
            <Menu.Item key="know-yourself">Know Yourself</Menu.Item>
            <Menu.Item key="embrace-feedback">Embrace Feedback</Menu.Item>
            <Menu.Item key="start-with-questions">Start with Questions</Menu.Item>
            <Menu.Item key="lean-into-the-hard-stuff">Lean Into the Hard Stuff</Menu.Item>
            <Menu.Item key="sense-and-respond">Sense and Respond</Menu.Item>
          </SubMenu>
          <SubMenu key="skills" title="Skills" className="skills-submenu">
            <Menu.Item key="what-individuals-contribute">Intro: What Individuals Contribute</Menu.Item>
            <Menu.Item key="a-certain-set-of-skills">A Certain Set of Skills</Menu.Item>
            <Menu.Item key="view-the-skills-matrix">View the Skills Matrix</Menu.Item>
          </SubMenu>
          <Menu.Item key="next-steps">Next Steps</Menu.Item>
          <Menu.Item key="summary">Summary</Menu.Item>
        </Menu>
        <BrowserView>
          <InstagramLinkIcon />
          <LinkedInLinkIcon />
        </BrowserView>
        <TabletView>
          <InstagramLinkIcon />
          <LinkedInLinkIcon />
        </TabletView>
      </nav>
    );
  }
}
